var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentHotOffFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.943 19.357A7.979 7.979 0 0112 22c-4.42 0-8-3.58-8-8 0-2.47.646-4.795 1.782-6.804l-3.49-3.489 1.415-1.414 18 18-1.414 1.414-2.35-2.35zm-6.622-6.621l-.021.004c-1.76.36-2.81 1.5-2.81 3.12 0 1.74 1.44 3.14 3.22 3.14 1.6 0 3.017-.783 3.889-1.987l-4.278-4.277z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14a8 8 0 01-.324 2.262l-3.212-3.212c-.08-.99-.262-1.958-.544-2.89a5.43 5.43 0 01-1.194 1.152L12.293 8.88c1.212-.582 1.947-1.89 1.947-3.409 0-2.15-.74-4.8-.74-4.8C17.41 3.8 20 8.61 20 14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHotOffFill);
export default __webpack_public_path__ + "25541133402ffac82f971c7ffa8a1a06.svg";
export { ForwardRef as ReactComponent };